import { ApiClient } from "client/base";
export class CloudContainerClient extends ApiClient {
    getContainerTag() {
        return this.base.get("v1/container/tag");
    }
}
